import { render, staticRenderFns, recyclableRender, components } from "./course-item.vue?vue&type=template&id=1990ede0&scoped=true&"
var renderjs
import script from "./course-item.vue?vue&type=script&lang=js&"
export * from "./course-item.vue?vue&type=script&lang=js&"
import style0 from "./course-item.vue?vue&type=style&index=0&id=1990ede0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990ede0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/course-item/course-item.vue"
export default component.exports